import { render, staticRenderFns } from "./AuctionDetailBids.vue?vue&type=template&id=2fa751dd&scoped=true&"
import script from "./AuctionDetailBids.vue?vue&type=script&lang=ts&"
export * from "./AuctionDetailBids.vue?vue&type=script&lang=ts&"
import style0 from "./AuctionDetailBids.vue?vue&type=style&index=0&id=2fa751dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa751dd",
  null
  
)

export default component.exports